<template>
  <div class="feedBack-content">
    <div class="content">
      <div class="base-item">
        <div class="title">{{ $t('asm_feedBack_content.ling_jian_xin_xi') }}</div>
        <div class="row">
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.ling_jian_bian_hao') }}</div>
            <div class="val">{{ info.partCode || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.ling_jian_ming_cheng') }}</div>
            <div class="val">{{ info.partName || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.ling_jian_gui_ge') }}</div>
            <div class="val">{{ info.partSpec || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.ling_jianSN') }}</div>
            <div class="val">{{ info.partSn || '-' }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.ling_jian_lei_bie') }}</div>
            <div class="val">{{ getDicValue('asm_part_class', info.partClass) || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.ling_jian_lei_xing') }}</div>
            <div class="val">{{ getDicValue('asm_part_type', info.partType) || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.ling_jian_shu_liang') }}：</div>
            <div class="val">{{ info.replaceNum || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.shi_fou_jin_shui') }}</div>
            <div class="val">{{ getDicValue('isynergy_cloud_bool', info.isSoak) || '-' }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col col-12">
            <div class="key">{{ $t('asm_feedBack_content.gu_zhang_miao_shu') }}</div>
            <div class="val">{{ info.feedBackDesc || '-' }}</div>
          </div>
          <div class="col col-12">
            <div class="key">{{ $t('asm_feedBack_content.gong_dan_miao_shu') }}</div>
            <div class="val">{{ info.workOrderDesc || '-' }}</div>
          </div>
        </div>
        <div class="img-content" v-if="showImg">
          <div class="img-item" v-for="(item, index) in imgList" :key="index">
            <img :src="getAttachUrl(item)" class="img" />
          </div>
        </div>
      </div>
      <div class="base-item">
        <div class="title">{{ $t('asm_feedBack_content.gong_dan_xin_xi') }}</div>
        <div class="row">
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.gong_dan_bian_hao') }}</div>
            <div class="val">{{ info.workOrderCode || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.gong_dan_lei_xing') }}</div>
            <div class="val">{{ getDicValue('asm_work_order_type', info.workOrderType) || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.gong_dan_zhuang_tai') }}</div>
            <div class="val">{{ getDicValue('asm_work_order_state', info.workOrderState) || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.chuang_jian_fang_shi') }}</div>
            <div class="val">{{ getDicValue('asm_case_order_create_mode', info.createMode) || '-' }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.shang_bao_ren') }}</div>
            <div class="val">{{ info.creator || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.shang_bao_shi_jian') }}</div>
            <div class="val">{{ momentAmPm($momentLocal(info.gmtCreate) || '-') }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.shou_hou_gong_si') }}</div>
            <div class="val">{{ info.afterServiceName || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.shgcs') }}</div>
            <div class="val">{{ info.technicianName || '-' }} {{ info.technicianPhone }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.chan_pin_xing_hao') }}</div>
            <div class="val">{{ info.productCode || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.ji_shen_hao') }}</div>
            <div class="val">{{ info.bodyNum || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.ye_wu_zhuang_tai') }}</div>
            <div class="val">{{ getDicValue('order_device_biz_state', info.bizState) || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.ye_wu_lei_xing') }}</div>
            <div class="val">{{ getDicValue('dms_device_biz_type', info.deviceBizType) || '-' }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.he_tong_bian_hao') }}</div>
            <div class="val">{{ info.contractNo || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.ding_dan_lei_xing') }}</div>
            <div class="val">{{ getDicValue('crm_contract_type', info.orderType) || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.zu_lin_fang') }}/{{ $t('asm_feedBack_content.gou_mai_fang') }}</div>
            <div class="val">{{ info.customerName || '-' }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.xiang_mu_ming_cheng') }}</div>
            <div class="val">{{ info.locationName || '-' }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.zong_bu_fa_huo_ri_qi') }}</div>
            <div class="val">{{ momentAmPm($momentLocal(info.hqShipmentTime) || '-') }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.shou_ci_qi_zu_ri_qi') }}</div>
            <div class="val">{{ momentAmPm($momentLocal(info.firstRentalTime) || '-') }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('asm_feedBack_content.kai_shi_fu_wu_ri_qi') }}</div>
            <div class="val">{{ momentAmPm($momentLocal(info.rentalStartTime) || '-') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col col-12">
            <div class="key">{{ $t('asm_feedBack_content.he_tong_di_zhi') }}</div>
            <div class="val">{{ info.useLocation || '-' }}</div>
          </div>
          <div class="col col-12">
            <div class="key">{{ $t('asm_feedBack_content.shi_shi_di_zhi') }}</div>
            <div class="val">{{ info.gpsAddress || '-' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 *
 */
// import apis from '@/utils/apis';
// import acceptanceCommentsDialog from './acceptance_comments_dialog';

export default {
  name: '',
  inject: ['getInfo'],
  mixins: [],
  // components: { acceptanceCommentsDialog },
  props: {
    feedBackId: [Number, String],
  },
  data() {
    return {
      imgList: [],
    };
  },
  computed: {
    // 是否展示图片
    showImg() {
      return this.imgList.length;
    },
    info() {
      return this.getInfo();
    },
  },
  watch: {
    feedBackId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.init();
        }
      },
    },
  },

  methods: {
    init() {
      // this.info = {};
      // this.$getJSON(`${apis.caseOrderInfo}/${this.feedBackId}`, {}, true).then((res) => {
      //   this.info = res.data;
      // });

      this.$getFileList({ bizId: this.feedBackId, bizType: 'asm.feedBack.icon' }).then((list) => {
        this.imgList = list;
      });
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.feedBack-content {
  padding: 0 16px;

  .img-content {
    overflow: hidden;
    margin-top: 24px;
    .img-item {
      float: left;
      margin-right: 15px;
      width: 100px;
      height: 100px;
      border-radius: 4px;
      border: 1px solid #ccc;
      position: relative;

      .img {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        max-width: 95%;
        max-height: 95%;
      }
    }
  }
  .item-title {
    margin: 16px 0;
  }

  .el-col {
    font-size: 12px;
    color: #262626;
    line-height: 24px;
    span {
      color: #6e6e6e;
    }
  }

  .base-item {
    font-size: 12px;
    padding-bottom: 32px;
    border-bottom: 1px solid #eef2f8;

    &:nth-child(n + 2) {
      margin-top: 7px;
    }

    overflow: hidden;
    .title {
      color: #0d9ae0;
      font-weight: bold;
      line-height: 16px;
      margin-top: 24px;
    }
    .row {
      overflow: hidden;
      .col {
        float: left;
        width: 25%;
        margin-top: 24px;
        &.col-12 {
          width: 50%;
        }
        &.long {
          width: 100%;
        }
        .key {
          color: #98a6ad;
          line-height: 16px;
        }
        .val {
          margin-top: 8px;
          font-weight: bold;
          color: #495057;
        }
        .detail {
          color: #0d9ae0;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
